namespace $.$$ {

	export class $shm_dashboard_admin_user_dashboards_follower extends $.$shm_dashboard_admin_user_dashboards_follower {

		@ $mol_mem
		pos(): { left: number, top: number } | null {
			// pos is implemented in the final $mol_follower view class, not
			// declared by its generated view.tree API.
			const pos = ( this.$.$mol_follower.prototype as $mol_follower ).pos.call( this )
			if( !pos ) return pos
			const rect = this.view_rect()
			const previous = $mol_wire_probe( ()=> this.pos() )
			// pos is a translation, whereas the viewport bounds are absolute.
			// Popover layout may already contribute a nonzero horizontal origin.
			const origin = ( rect?.left ?? 0 ) - ( previous?.left ?? 0 )
			const viewport = this.$.$mol_window.size().width
			const left = $shm_dashboard_admin_user_dashboards_follower_left( pos.left, origin, rect?.width ?? 0, viewport )
			return { ...pos, left }
		}

	}

}
